import axios from "axios";

const InitialState = {
  counterOrganizations: null,
  counterResources: null,
  counterPersons: null,
  counterUsers: null,
  countPrograms: null,
  countSites: null,
  countReferences: null,
  counterSkills: null
};

const MANAGE_OOP_RESOURCES_INDEX_TYPE = "MANAGE_OOP_RESOURCES_INDEX_TYPE";

function counterOrganizationsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-organizations", {
    headers: {'Accept': 'application/json'},
  });
}

function counterResourcesGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-resources", {
    headers: {'Accept': 'application/json'},
  });
}

function counterPersonsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-persons", {
    headers: {'Accept': 'application/json'},
  });
}

function counterUsersGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-users", {
    headers: {'Accept': 'application/json'},
  });
}

function counterProgramsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-programs", {
    headers: {'Accept': 'application/json'},
  });
}

function counterSitesGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-sites", {
    headers: {'Accept': 'application/json'},
  });
}

function counterReferencesGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-references", {
    headers: {'Accept': 'application/json'},
  });
}

function counterSkillsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-skills", {
    headers: {'Accept': 'application/json'},
  });
}


function counterOrganizationsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterOrganizations: item
      }
    }
  }
}

function counterResourcesReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterResources: item
      }
    }
  }
}

function counterPersonsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterPersons: item
      }
    }
  }
}

function counterUsersReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterUsers: item
      }
    }
  }
}

function counterProgramsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterPrograms: item
      }
    }
  }
}

function counterSitesReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterSites: item
      }
    }
  }
}

function counterReferencesReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterReferences: item
      }
    }
  }
}

function counterSkillsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterSkills: item
      }
    }
  }
}


export function counterOrganizationsQuery() {
  return (dispatch) => {
    return counterOrganizationsGetRequest()
      .then(response => {
        dispatch(counterOrganizationsReceive(response.data))
      }, err => {
        dispatch(counterOrganizationsReceive(null))
      })
  }
}

export function counterResourcesQuery() {
  return (dispatch) => {
    return counterResourcesGetRequest()
      .then(response => {
        dispatch(counterResourcesReceive(response.data))
      }, err => {
        dispatch(counterResourcesReceive(null))
      })
  }
}

export function counterPersonsQuery() {
  return (dispatch) => {
    return counterPersonsGetRequest()
      .then(response => {
        dispatch(counterPersonsReceive(response.data))
      }, err => {
        dispatch(counterPersonsReceive(null))
      })
  }
}

export function counterUsersQuery() {
  return (dispatch) => {
    return counterUsersGetRequest()
      .then(response => {
        dispatch(counterUsersReceive(response.data))
      }, err => {
        dispatch(counterUsersReceive(null))
      })
  }
}

export function counterProgramsQuery() {
  return (dispatch) => {
    return counterProgramsGetRequest()
      .then(response => {
        dispatch(counterProgramsReceive(response.data))
      }, err => {
        dispatch(counterProgramsReceive(null))
      })
  }
}


export function counterSitesQuery() {
  return (dispatch) => {
    return counterSitesGetRequest()
      .then(response => {
        dispatch(counterSitesReceive(response.data))
      }, err => {
        dispatch(counterSitesReceive(null))
      })
  }
}

export function counterReferencesQuery() {
  return (dispatch) => {
    return counterReferencesGetRequest()
      .then(response => {
        dispatch(counterReferencesReceive(response.data))
      }, err => {
        dispatch(counterReferencesReceive(null))
      })
  }
}

export function counterSkillsQuery() {
  return (dispatch) => {
    return counterSkillsGetRequest()
      .then(response => {
        dispatch(counterSkillsReceive(response.data))
      }, err => {
        dispatch(counterSkillsReceive(null))
      })
  }
}



export function reducer(state = InitialState, action) {
  if (action.type === MANAGE_OOP_RESOURCES_INDEX_TYPE) {
    return action.reduce(state)
  }
  return state;
}
